import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import Footer from '../../components/common/Footer';
import MutualFundPage from '../../components/modules/mutualFund';
import { up } from 'styled-breakpoints';
import NavigationBar from '../../components/common/NavigationBar';
import API from '../../API';
import { useHeaderHeight } from '../../components/common/Header';
import Container from '../../components/common/Container';
import KycModals from '../../components/modules/kyc/KycModals';
import { KYC_MODALS } from '../../constants/Kyc';
import { useRouter } from 'next/router';
import { useAppContext } from '../../store';
import { routes } from '../../config/routes';
import FullPageLoader from '../../components/common/FullPageLoader';
import { CHANNEL_ID, INITIATE_ACTION, TOKEN } from '../../constants/common';
import GTM from '../../GTM';
import { navigateToLoginInNewTab, navigateToUrl } from '../../API/router';
import { MF_BANNER_NAME } from '../../constants/ExplorePage';
import { navigateToV2 } from '../../utils/silentLogin';
import { unsetBrowserConfig } from '../../API/utils';
import { getTransactionRoute, TransactionRoute } from '../../utils/transaction';
import { Tooltip } from 'pfm-ui-components';
import OverlayBanner from '../../components/common/OverlayBanner';
import banner from '../../../public/banners/Mf-Sip-web.jpg';
import mobileBanner from '../../../public/banners/Mf-Sip-mobile.jpg';
import DEVICE_TYPE from '../../constants/device';
import { useDeviceType } from '../../utils/deviceType';
export interface SearchResult {
  amficode: string;
  vcContentSecurityCode: string;
  vcSchemeName: string;
  isnfo: string;
}

interface RiskProfile {
  checkForRiskProfile: boolean;
  profile: string;
  lastUpdatedDate: string;
}
interface SearchResultData {
  data?: {
    data?: Array<SearchResult>;
  };
}

interface RiskProfileData {
  data?: {
    data?: RiskProfile;
  };
}

export interface BannerDetails {
  imageURL: string;
  imageDescription: string;
  actionType: string;
  screen: string;
  startDate: string;
  endDate: string;
}

let SearchTimer = null;

export default function Explore() {
  const router = useRouter();
  const { showKycWarning, initiateAction = '' } = router.query;
  const [showKycModal, setShowKycModal] = useState(false);
  const [cookie, setCookie, removeCookie] = useCookies([TOKEN]);
  const [searchKey, setSearchKey] = useState('');
  const [searchResult, setSearchResult] = useState(undefined);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [riskProfileData, setRiskProfile] = useState<RiskProfile>(null);
  const [bannerDetails, setBannerDetails] = useState([]);
  const [showPFMV2NavigationButton, setShowPFMV2NavigationButton] = useState(false);
  const [loader, setLoader] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [modalMsg, setModalMsg] = useState(null);
  const { state, setState } = useAppContext();
  const [showMFUserGuide, setMFUserGuide] = useState(0);
  const [hasPortfolio, setHasPortfolio] = useState(false);
  const [showOverlayBanner, setShowOverlayBanner] = useState(false);
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;

  useEffect(() => {
    if (state.customerId) {
      setIsLoggedIn(true);
    }
  }, [state, state.customerId]);

  useEffect(() => {
    if (initiateAction === INITIATE_ACTION.INVEST_BASIS_RISK_PROFILE) {
      onRiskProfileClick();
    }
  }, [initiateAction]);

  useEffect(() => {
    if (!!showKycWarning) {
      // setShowKycModal(true);
      setModalType(KYC_MODALS.MFL_WARNING);
    }
  }, [showKycWarning]);

  useEffect(() => {
    if (searchKey && !!searchKey.length && searchKey.length > 2) {
      if (SearchTimer) {
        clearTimeout(SearchTimer);
      }
      SearchTimer = setTimeout(() => {
        API.fetch(API.scheme.getSchemesSearchUrl(searchKey)).then((searchResultData: SearchResultData) => {
          if (searchResultData) {
            setSearchResult(searchResultData.data.data);
          }
        });
      }, 200);
    } else {
      setSearchResult(undefined);
    }
  }, [searchKey]);

  useEffect(() => {
    unsetBrowserConfig();
    if (!state.isOverlayBannerDisplayed) {
      API.portfolioTransaction
        .getBannerDetails()
        .then((resData: any) => {
          if (resData?.data?.data?.showOverlayBanner) {
            setState({ ...state, isOverlayBannerDisplayed: true });
            setShowOverlayBanner(resData?.data?.data?.showOverlayBanner);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    API.banners.getBanners().then((res) => {
      if (res) {
        setBannerDetails(res);
      }
    });
    const getCartDetails = async () => {
      const cart: any = await API.cart.getCartDetails();
      setState({ ...state, cartData: cart.data.data.contents, cartSchemeCount: cart.data.data.contents.length });
    };
    getCartDetails().catch((err) => err);
    GTM.mflp.mutualFundHomePageLoad();
  }, []);

  // useEffect(() => {
  //   API.fetch(API.customer.getRiskProfile())
  //     .then((riskProfileData: RiskProfileData) => {})
  //     .catch((error) => {});
  // }, []);

  const navigateToLogin = (channelId?: string) => {
    navigateToLoginInNewTab(channelId);
  };

  const navigationToV2 = () => {
    navigateToV2(state.customerId, cookie[CHANNEL_ID])
      .then((res: any) => {
        navigateToUrl(res?.data?.data?.redirectionUrl);
      })
      .catch((error) => {
        setModalType(error?.errorCode);
        setModalMsg(error?.errorMsg?.message);
      });
  };

  const onRiskProfileClick = () => {
    setLoader(true);
    // API.registration
    //   .getKycDetails()
    //   .then((res: any) => {
    //     const kycDetails = res?.data?.data;
    //     setLoader(false);
    //     const shouldShowRiskProfile = kycDetails?.isRiskProfileExpired || !kycDetails?.isRiskProfileCompleted;
    //     if (shouldShowRiskProfile) {
    //       // router.push(routes.GOAL_SETTING.url);
    //       router.push(routes.RISK_PROFILE.url);
    //     } else {
    //       // Fetch the risk profile from API and add it to query param of Explore page
    //       API.fetch(API.customer.getRiskProfile())
    //       .then((riskProfileData: RiskProfileData) => {
    //           router.push(routes.GOAL_SETTING.url);
    //           //const exploreUrl = routes.EXPLORE.url + `?riskProfile=${riskProfileData?.data?.data?.profile}`;
    //           //router.push(exploreUrl + `&userFlow=${EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE}`, exploreUrl);
    //         })
    //         .catch((error) => {
    //           setModalType(error?.errorCode);
    //           setModalMsg(error?.errorMsg?.message);
    //         });
    //     }
    //   })
    //   .catch((error: any) => {
    //     setLoader(false);
    //     setModalType(error?.errorCode);
    //     setModalMsg(error?.errorMsg?.message);
    //   });
    const investRoute = routes.GOAL_SETTING.url;
    // const invIdeaScheme = getBackButtonTitleSchemeListPage(subCategory.toString(), null, null, userFlow?.toString());
    // const asSuccessRoute = `&userFlow=${userFlow}${
    // userFlow === EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS
    // ? `&invIdeaScheme=${replaceAllOccurenceOfCharacter(invIdeaScheme?.toString(), ' & ', ' and ')}`
    // : ''
    // }`;
    // const fallBackRoute = `&fallBackTo=${router.asPath}`;

    getTransactionRoute(investRoute, null, investRoute).then((res: TransactionRoute) => {
      setState({ ...state, kyc: res.kycData, successRoute: res.successRoute });
      setLoader(false);
      router.push(res.url, res.as);
    });
  };

  function onBannerClick(actionType: string, screen: string, bannerPosition: string, bannerName: string) {
    if (isLoggedIn) {
      if (actionType && screen) {
        setState({ ...state, schemeListingState: null });
        router.push(screen);
      }
    } else {
      navigateToLogin(state.channelId);
    }
  }

  const closeModal = () => {
    setModalType(null);
  };

  const onUserGuideClick = () => {
    setMFUserGuide(showMFUserGuide + 1);
  };

  const updateHasPortfolio = (status) => {
    setHasPortfolio(status);
  };

  const headerHeight = useHeaderHeight();
  return (
    <>
      <MutualFundPageWrapper>
        <NavigationBarContainer headerHeight={headerHeight}>
          <NavigationBar
            onUserGuideClick={onUserGuideClick}
            updateHasPortfolio={updateHasPortfolio}
            activeMenu={2}
            setShowPFMV2NavigationButton={setShowPFMV2NavigationButton}
          />
        </NavigationBarContainer>
        <MutualFundContainer>
          <MutualFundWrapper fullWidthInMobile>
            <MutualFundPage
              {...{
                searchKey,
                setSearchKey,
                searchResult,
                navigateToLogin,
                isLoggedIn,
                onRiskProfileClick,
                onBannerClick,
                bannerDetails,
                navigationToV2,
                showPFMV2NavigationButton,
                showMFUserGuide,
                hasPortfolio,
              }}
            />
          </MutualFundWrapper>
          <Footer hasNavigationBar={true} />
        </MutualFundContainer>
      </MutualFundPageWrapper>
      {false && (
        <OverlayBanner
          isOpen={showOverlayBanner}
          closeModal={() => setShowOverlayBanner(false)}
          isMobile={isMobile}
          redirectionData={routes.INSTA_SIP.url}
          banner={banner}
          mobileBanner={mobileBanner}
          onRiskProfileClick={onRiskProfileClick}
          bannerId='mf_banner'
          bannerName = {MF_BANNER_NAME}
        />
      )}
      {loader && <FullPageLoader />}
      <KycModals modalType={modalType} modalMsg={modalMsg} handleModalCommand={closeModal} />
    </>
  );
}

const MutualFundWrapper = styled(Container)`
  padding: 0;
  min-height: 100vh;
`;

const MutualFundPageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const MutualFundContainer = styled.article`
  scrollbar-color: #f6f7f8 #f6f7f8;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const NavigationBarContainer = styled.article<{ headerHeight: string }>`
  position: sticky;
  bottom: 0;
  order: 1;
  z-index: 91;
  ${up('md')} {
    top: ${(props) => props.headerHeight};
    order: 0;
  }
`;
